const styles = {
    modal: {
        fontFamily: 'DM Sans'
    }
}

export default styles